import { ConfigurationSettings } from "../../../models/configuration-settings";
import { clients } from "lib/https";
import { IFileData } from "../hooks/use-mock-files-query";
import { columnIdToSortKey, extensionToFileType } from "../utils/file-manager";
import { formatFileSize } from "../utils/file-manager";
import { SortingState } from "@tanstack/react-table";

interface MediaFile {
  fileId: string;
  fileName: string;
  extension: string;
  createdDate: Date;
  lastUpdatedDate: Date;
  size: number;
}

interface TransformedResponse {
    data: IFileData[];
    totalCount: number;
}

interface MediaFilesResponse {
  totalCount: number;
  page: number;
  pageSize: number;
  data: MediaFile[];
}

interface MemoizedQueryParams {
    page: number;
    pageSize: number;
    filterName: string;
    filterFileType: string;
    startTs: number | undefined;
    endTs: number | undefined;
    sort?: SortingState
}

export const fetchMediaFiles = async (configurationSettings: ConfigurationSettings, queryParams: MemoizedQueryParams): Promise<TransformedResponse> => {
    const baseUrl = `${configurationSettings.paths.seliseAiBaseUrl}`;
    // const params = new URLSearchParams({
    //     page: queryParams.page.toString(),
    //     pageSize: queryParams.pageSize.toString()
    // })
    // if (queryParams.filterName) {
    //     params.set('search', queryParams.filterName);
    // }
    // if (queryParams.filterFileType) {
    //     params.set('fileType', queryParams.filterFileType);
    // }
    // if (queryParams.startTs) {
    //     params.set('startTs', queryParams.startTs.toString());
    // }
    // if (queryParams.endTs) {
    //     params.set('endTs', queryParams.endTs.toString());
    // }
    // params.set('sortBy', queryParams.sort && queryParams.sort.length > 0 ? columnIdToSortKey(queryParams.sort[0].id) : 'createdDate');
    // params.set('order', queryParams.sort && queryParams.sort.length > 0 ? (queryParams.sort[0].desc ? 'desc' : 'asc') : 'desc');

    const body: Record<string, any> = {
        page: queryParams.page + 1,
        pageSize: queryParams.pageSize,
        sortBy:
            queryParams.sort && queryParams.sort.length > 0
                ? columnIdToSortKey(queryParams.sort[0].id)
                : 'createdDate',
        order:
            queryParams.sort && queryParams.sort.length > 0
                ? queryParams.sort[0].desc
                    ? 'desc'
                    : 'asc'
                : 'desc',
    };

    if (queryParams.filterName) {
        body.search = queryParams.filterName;
    }

    if (queryParams.filterFileType) {
         body.fileTypes = queryParams.filterFileType
        .split(',')
        .map(t => t.trim())
        .filter(Boolean);
    }

    if (queryParams.startTs) {
        body.startTs = queryParams.startTs;
    }
    if (queryParams.endTs) {
        body.endTs = queryParams.endTs;
    }

    const url = `${baseUrl}${configurationSettings?.paths?.seliseAi.mediaLibrary}`;
    const response = await clients.post<MediaFilesResponse>(url, configurationSettings.blocksKey, JSON.stringify(body));
    const transformedResponse: TransformedResponse = {
        data: response.data.map((file) => ({
            id: file.fileId,
            name: file.fileName,
            createdDate: new Date(file.createdDate),
            lastModified: new Date(file.lastUpdatedDate || file.createdDate),
            fileType: extensionToFileType(file.extension),
            size: formatFileSize(file.size)
        })),
        totalCount: response.totalCount,
    };
        return transformedResponse;
}